import { IOwnerVisitsData } from "../types/ownerDashboard.types";

export function resolvePastVisitsTotal(
  visitsData: IOwnerVisitsData | null,
  schedulesFallback?: number
): number {
  if (visitsData?.past_visits?.total != null) {
    return visitsData.past_visits.total;
  }

  return schedulesFallback ?? 0;
}

export function hasVisitsContent(visitsData: IOwnerVisitsData | null): boolean {
  if (!visitsData) {
    return false;
  }

  const hasPastVisits = visitsData.past_visits.total > 0;
  const hasUpcomingVisits = visitsData.upcoming_visits.total > 0;

  return hasPastVisits || hasUpcomingVisits;
}
